import styled from "styled-components";

import { NotificationStyledProps as Props } from "./Notification.types";
import { getMaxWidth } from "utils/styling.utils";

const NotificationStyled = styled.div<Props>`
  width: calc(${getMaxWidth()} - 1.6rem);
  max-width: 40rem;
  max-height: 16.4rem;
  overflow-y: auto;
  box-shadow: 0 0.4rem 1.2rem var(--palette-mid-blue-s15-l20),
    0 0.2rem 0.2rem var(--palette-mid-blue-s15-l20),
    inset 0 0 0 0.2rem var(--palette-mid-blue-s15-l20);
  padding: 2rem;
  border-radius: 0.8rem;
  background-color: var(--palette-dark-blue-s13-l11);
  position: relative;

  .Notification {
    &__close {
      position: absolute;
      right: 1.6rem;
      top: 1.6rem;
      cursor: pointer;
    }
  }
`;

export default NotificationStyled;
